import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from './AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from './useAutomationApiPerType';
import { scheduledJobsSortOptions } from './consts';
import { AutomationScheduledJobsContextProvider } from './AutomationScheduledJobsContextProvider';
import { selectScheduledJobs } from '../../reducers/global/scheduledJobReducers';

const ScheduledJobs = () => {
  const automationsVariant = AutomationFormVariant.SCHEDULED_JOBS;
  const scheduledJobs = useSelector(selectScheduledJobs);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: automationsVariant });
  if (!scheduledJobs) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationScheduledJobsContextProvider>
          <AutomationDialogContent
            automations={scheduledJobs ?? []}
            onDeleteAutomation={onDeleteAutomation}
            crmOrgId={crmOrg.id}
            onSaveOrCreate={onSaveOrCreate}
            onToggleActivation={onToggleActivation}
            sortOptions={scheduledJobsSortOptions}
            disableCanvasTemplates={true}
            onDeployAutomation={onDeployAutomation}
            filters={{}}
          />
        </AutomationScheduledJobsContextProvider>
      )}
    </>
  );
};

export default ScheduledJobs;
